import easings from "theme/config/easings";

const primaryTransition = `500ms ${easings.easeOutCustom}`;

const transitions = {
    primary: `300ms ease-out`,
    primaryFast: `300ms ${easings.easeOutCustom}`,
    primarySlow: `1000ms ${easings.easeOutCustom}`,
    secondary: `500ms ease`,
    secondaryFast: `300ms ease`,
    secondarySlow: `800ms ease`,
    //custom transitions
    scrollIndicator: `1750ms ease-in-out`,
    skeletonLoading: "2000ms ease-in-out",
    headerAnimation: primaryTransition,
} as const;

export type TransitionType = typeof transitions;

export default transitions;
